export enum DashboardView {
    table = 'table',
    grid = 'grid'
}

export class UserPreferenceGlobalInfo {
    theme: string; //standard, high
}

export class UserPreferenceHomeInfo {
    overviewLayout: string;
    device: {
        view?: DashboardView; // table or grid mode
        pageCapacity?: number; //number of devices shown in a page
        showSubDevGroupPopupHint?: boolean;
        tableLayoutColumnOptionMap?: { [key: string]: boolean }; // visible cols
        searchOptions?: { [key: string]: boolean }; // search keys
    };
}

export class UserPreferenceEventLogInfo {
    filter: {
        level?: { [levelName: string]: boolean },
        time?: { beginDate?: string, beginTime?: string, endDate?: string, endTime?: string },
        event?: { [categoryName: string]: { [eventName: string]: boolean } }
    }
}

export class UserPreferenceLicenseInfo {
    filter: {
        licenseType: { [type: string]: boolean },
        expiryDate: { beginDate?: string, endDate?: string }
    }
}

export class UserPreferenceInfo {
    global: UserPreferenceGlobalInfo;
    home: UserPreferenceHomeInfo;
    eventLog: UserPreferenceEventLogInfo;
    license: UserPreferenceLicenseInfo;
}